import React from 'react'
import isMobile from 'ismobilejs'
import { Carousel, Container, Image } from '@pmi/pmi-iqos-ds-react'
import { Video, LazyImage } from '@pmi/pmi-iqos-shared-react'

const MediaContainer = ({ children }) => {
  return (
    <Container
      display={Container.displays.flex}
      alignItems={Container.alignItemsValues.center}
      justifyContent={Container.justifyContentValues.center}
      fullWidth
      height={['80', '128']}
      p="5">
      {children}
    </Container>
  )
}

const ProductCarousel = ({
  images = [],
  videos = [],
  prodImages = [],
  onFullScreenHandler
}) => {
  const defaultImage =
    prodImages && prodImages.length > 0 ? prodImages[0] : null
  const lastItems = images && images.length > 0 ? images.slice(1) : []
  const firstItem = images && images.length > 0 ? images[0] : null
  const items = [...(videos && videos.length > 0 ? videos : []), ...lastItems]
  firstItem && items.unshift(firstItem)
  const showArrows = !isMobile().any

  return items.length > 0 ? (
    <Carousel
      showArrows={showArrows}
      showFullScreen
      getItemInfo={index => items[index] && items[index].alt}
      data-testing-prefix="ProductDetail"
      onFullScreenHandler={onFullScreenHandler}>
      {items.map((item, index) => (
        <MediaContainer key={index}>
          {item.path ? (
            <Image src={item.path} alt={item.alt} />
          ) : (
            <Video item={item} defaultImage={defaultImage} />
          )}
        </MediaContainer>
      ))}
    </Carousel>
  ) : (
    <MediaContainer>
      <LazyImage />
    </MediaContainer>
  )
}

export default ProductCarousel
